module.exports = __webpack_public_path__ + "static/img/zyskqhxqbp.c65bcd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/zyskqhxqbp.jpg
// module id = /EG8
// module chunks = 21